import React, { useEffect, useState } from "react";
import AnimatedNumber from "./AnimatedNumber";

// KPI tile as a chrome stat panel — sunken bevel well, micro-label, and a
// JetBrains Mono figure. No border-radius, no soft shadows.
//
// `value` renders with AnimatedNumber when given a `numeric` + `format` combo;
// otherwise the string is shown as-is (used for "—" min-N gate states).
// A fade-in-up transition on mount avoids the whole dashboard popping in.
// `tone` is accepted for call-site compatibility but the chrome panel has a
// single sunken-well treatment.
export default function StatCard({ label, value, numeric, format, caption, tone = "paper" }) {
  const [entered, setEntered] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const displayValue =
    typeof numeric === "number" && format
      ? <AnimatedNumber value={numeric} format={format} />
      : value;

  return (
    <div
      className="win95-statpanel"
      style={{
        padding: "8px 12px",
        minWidth: 0,
        opacity: entered ? 1 : 0,
        transform: entered ? "translateY(0)" : "translateY(6px)",
        transition: "opacity 360ms ease-out, transform 360ms ease-out",
      }}
    >
      <div className="win95-statpanel__label" style={{ whiteSpace: "normal", marginBottom: 4 }}>
        {label}
      </div>
      <div
        className="win95-statpanel__figure"
        style={{
          fontSize: "var(--tc-data-lg)",
          fontWeight: 500,
          lineHeight: 1.15,
          color: "var(--chrome-outline)",
        }}
      >
        {displayValue}
      </div>
      {caption && (
        <div
          style={{
            fontFamily: "var(--font-chrome)",
            fontSize: 11,
            color: "var(--chrome-text-soft)",
            marginTop: 4,
          }}
        >
          {caption}
        </div>
      )}
    </div>
  );
}
